import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=0926918e&scoped=true&"
import script from "./approve.vue?vue&type=script&lang=js&"
export * from "./approve.vue?vue&type=script&lang=js&"
import style0 from "./approve.vue?vue&type=style&index=0&id=0926918e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0926918e",
  null
  
)

export default component.exports